const ForceUnlocked = () => (
  <svg
    width="144"
    height="145"
    viewBox="0 0 144 145"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="72" cy="72.5" r="72" fill="url(#paint0_linear_2196_40213)" />
    <path
      d="M71.9998 39.4167C63.4106 39.4592 56.459 46.4108 56.4165 55V67.75H59.2498V55C59.2498 47.9578 64.9576 42.25 71.9998 42.25C79.0421 42.25 84.7498 47.9578 84.7498 55C84.7498 55.782 85.3845 56.4167 86.1665 56.4167C86.9485 56.4167 87.5832 55.782 87.5832 55C87.5393 46.4122 80.5877 39.4606 71.9998 39.4167Z"
      fill="url(#paint1_linear_2196_40213)"
    />
    <path
      d="M94.6666 66.3334H49.3333C46.9858 66.3334 45.0833 68.236 45.0833 70.5834V100.333C45.0833 102.681 46.9858 104.583 49.3333 104.583H94.6666C97.014 104.583 98.9166 102.681 98.9166 100.333V70.5834C98.9166 68.236 97.014 66.3334 94.6666 66.3334Z"
      fill="url(#paint2_linear_2196_40213)"
    />
    <path
      d="M79.0832 81.9167C79.0832 78.0053 75.9113 74.8334 71.9998 74.8334C68.0884 74.8334 64.9165 78.0053 64.9165 81.9167C64.9165 85.3436 67.3503 88.201 70.5832 88.857V94.6667C70.5832 95.4487 71.2164 96.0834 71.9998 96.0834C72.7833 96.0834 73.4165 95.4487 73.4165 94.6667V88.857C76.6493 88.201 79.0832 85.3436 79.0832 81.9167Z"
      fill="url(#paint3_linear_2196_40213)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_2196_40213"
        x1="72"
        y1="80"
        x2="-2.80142e-06"
        y2="0.999999"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EDEBE6" stopOpacity="0.96" />
        <stop offset="1" stopColor="#EDEBE6" stopOpacity="0.1" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_2196_40213"
        x1="71.9998"
        y1="39.4167"
        x2="71.9998"
        y2="67.75"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E0E0E6" />
        <stop offset="1" stopColor="#C2C3CD" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_2196_40213"
        x1="71.9999"
        y1="66.3334"
        x2="71.9999"
        y2="104.583"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFD36E" />
        <stop offset="1" stopColor="#F6B828" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_2196_40213"
        x1="71.9998"
        y1="74.8334"
        x2="71.9998"
        y2="103.158"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C88509" />
        <stop offset="1" stopColor="#F6B828" />
      </linearGradient>
    </defs>
  </svg>
)

export default ForceUnlocked
